namespace Matrix.Data {
    export class SecurityMatchRuleColumns {
        static columnsKey = 'Data.SecurityMatchRule';
    }
}
